import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import RotateWarning from './components/Rotatewarning.jsx';
import './index.css';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');

axios.defaults.baseURL = apiBaseUrl;

ReactDOM.createRoot(document.getElementById('root')).render(
  <>
    <React.StrictMode>
      <RotateWarning />
      <div className="app-content">
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </div>
    </React.StrictMode>
  </>
);
